export default __webpack_public_path__ + "static/media/flag2.91e71194.png";